import {
    PRODUCT_CAT_PICKER_LOADING,
    PRODUCT_CAT_PICKER_ERROR,
    PRODUCT_CAT_PICKER_SELECT,
    PRODUCT_CAT_PICKER_DATA,
} from './constants';

import { makePrivateApiCall } from '../../common/api';
import { authExpire } from '../../auth/actions';

export const loadProductSubcategories = (keyword, type) => dispatch => {
    dispatch({
        type: PRODUCT_CAT_PICKER_LOADING,
        payload: true,
    });

    makePrivateApiCall({
        url: `/product/category`,
        method: 'get', params: { keyword, type }
    }).then(res => {
        if (res.data) {
            dispatch({
                type: PRODUCT_CAT_PICKER_DATA,
                payload: res.data
            });
        }
    }).catch(err => {
        if (err.response && err.response.status === 401) {
            return dispatch(authExpire());
        }

        dispatch({
            type: PRODUCT_CAT_PICKER_ERROR,
            payload: err.message
        });
    });
};

export const selectProductSubcategory = (group) => (dispatch) => {
    dispatch({
        type: PRODUCT_CAT_PICKER_SELECT,
        payload: group
    });
};